/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {provisionKeys} from '../api'

export const useMutationProvisionKeys = createReactQueryMutationHook('provisionKeys', provisionKeys)
